export default __webpack_public_path__ + "static/johnson-cc895d6ca81e61b5e1dd1f80ae404d50.png";